import { gql } from 'graphql-request'

export const QueryBlockTeamMembers = gql`
  fragment FragmentBlockTeamMembers on BlockTeamMembersModelRecord {
    __typename
    id
    preface
    title
    shortDescription {
      value
    }
    background
    teamMembers {
      ...FragmentTeamMember
    }
    action {
      ...FragmentNavigationItem
    }
  }
`
export const BlockTeamMembers = {
  __typename: 'BlockTeamMembers',
  fragmentName: 'FragmentBlockTeamMembers',
  fragmentQuery: QueryBlockTeamMembers,
  fragments: []
}
